const viewMaps = new Map();

const findViewModel = (Component) => {
  if (!Component.viewModelNames) {
    return null;
  }
  if (Component.viewModelNames.length == 1) {
    return Component.viewModelNames[0];
  }
  return Component.viewModelNames;
}

export const mapViewModel = (views) => {
  Object.keys(views).forEach(pid => {
    viewMaps.set(pid, findViewModel(views[pid]))
  })
  return views;
}

export const getMainViewModel = (pid) => {
  return viewMaps.get(pid);
}
